var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleFacebookFill = function SvgCircleFacebookFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.5 83.5Q155 12 256 12t172.5 71.5T500 256t-71.5 172.5T256 500 83.5 428.5 12 256 83.5 83.5M308 186v-38h-34q-14 0-25.5 7.5T231 175t-6 27v21h-37v35h37v106h40V258h43v-35h-43v-25q0-5 2.5-8.5t6.5-3.5z"
  })));
};
export default SvgCircleFacebookFill;